import jQuery from 'jquery'
import moment from 'moment'

window.$ = window.jQuery = jQuery
window.moment = moment

jQuery.ajaxPrefilter(function (options, originalOptions, xhr) {
  if (options.crossDomain) return

  var meta = document.querySelector('meta[name="csrf-token"]')
  if (meta && meta.content) xhr.setRequestHeader('X-CSRF-Token', meta.content)
})
